import { render, staticRenderFns } from "./ComparativaReporteKPI.vue?vue&type=template&id=45b84a6a&"
import script from "./ComparativaReporteKPI.vue?vue&type=script&lang=js&"
export * from "./ComparativaReporteKPI.vue?vue&type=script&lang=js&"
import style0 from "./ComparativaReporteKPI.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports